export default {
  UPDATE_PARAMETER: 'UPDATE_PARAMETER',
  UPDATE_NUMBER_OF_ITEMS: 'UPDATE_NUMBER_OF_ITEMS',
  ADD_CATEGORY_ITEM: 'ADD_CATEGORY_ITEM',
  CHANGE_CATEGORY_ITEM_NAME: 'CHANGE_CATEGORY_ITEM_NAME',
  EDIT_CATEGORY_ITEM: 'EDIT_CATEGORY_ITEM',
  REMOVE_CATEGORY_ITEM: 'REMOVE_CATEGORY_ITEM',
};
